import { DTOWorkspace } from "../workspaces";
import { DTODesignSystem } from "./design-system";
import { z } from "zod";
export const DTOUserDesignSystemsResponse = z.object({
    designSystems: DTODesignSystem.array(),
    workspaces: DTOWorkspace.array(),
});
